import styled from 'styled-components';
import { Paper as MuiPaper } from '@mui/material';
export var Paper = styled(MuiPaper).withConfig({
  displayName: "style__Paper",
  componentId: "sc-9bwmpt-0"
})(["margin-bottom:1rem;"]);